import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'input', 'name' ];

  getFilename() {
    const fileInput = this.inputTarget;
    const fileCount = fileInput.files.length;
    const emptyText = this.nameTarget.dataset.emptyText || '';

    if (fileCount === 0) {
      this.nameTarget.textContent = emptyText;
    } else if (fileCount === 1) {
      this.nameTarget.textContent = fileInput.files[0].name;
    } else {
      this.nameTarget.textContent = `${fileCount} fichiers sélectionnés`;
    }
  }
}
